<div>
  <div class="kt-footer kt-footer--extended kt-grid__item" id="kt_footer">
    <!--    <div class="kt-footer__top">
      <div class="kt-container container">
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-6 col-md-3 col-sm-6">
                <div class="kt-footer__section">
                  <h3 class="kt-footer__title">TABBASSI.COM</h3>
                  <div class="kt-footer__content">
                    <div class="kt-footer__nav">
                      <div class="kt-footer__nav-section">
                        <a routerLink="/races">All races</a>
                        <a routerLink="/next-races">Next Races</a>
                        <a>{{ "HOME.HIGHLIGHTS" | translate }}</a>
                        <a>Head 2 Head</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-sm-6">
                <div class="kt-footer__section">
                  <h3 class="kt-footer__title">SUPPORT</h3>
                  <div class="kt-footer__content">
                    <div class="kt-footer__nav">
                      <div class="kt-footer__nav-section">
                        <a>Forgot password</a>
                        <a>Help</a>
                        <a>Contact</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-sm-6">
                <div class="kt-footer__section">
                  <h3 class="kt-footer__title">LINKS</h3>
                  <div class="kt-footer__content">
                    <div class="kt-footer__nav">
                      <div class="kt-footer__nav-section">
                        <a>Investor relations</a><a>Cookies</a
                        ><a>Gambling addiction</a><a>Partner programme</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-sm-6">
                <div class="kt-footer__section">
                  <h3 class="kt-footer__title">INFORMATION</h3>
                  <div class="kt-footer__content">
                    <div class="kt-footer__nav">
                      <div class="kt-footer__nav-section">
                        <a>GTC</a><a>Legal information</a><a>Data protection</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="kt-footer__section">
              <h3 class="kt-footer__title">Get In Touch</h3>
              <div class="kt-footer__content">
                <form
                  action=""
                  class="kt-footer__subscribe ng-untouched ng-pristine ng-valid"
                  novalidate=""
                >
                  <div class="input-group">
                    <input
                      class="form-control"
                      placeholder="Enter Your Email"
                      type="text"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-info" type="button">Join</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div> -->
    <div class="kt-footer__bottom">
      <div class="container">
        <div class="kt-footer__wrapper">
          <div class="kt-footer__logo">
            <div class="kt-footer__copyright">
              {{currentYear}}&nbsp;©&nbsp; <a class="text-white" routerLink="/">Racebet365</a>
            </div>
          </div>
          <div class="kt-footer__menu">
            <a href="#">Team</a>
            <a href="#">Contact</a>
            <a>
              <app-language-toolbar></app-language-toolbar>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-none d-md-block">
  <button (click)="topFunction()" id="myBtn" title="Go to top">
    <i class="fa fa-arrow-up"></i>
  </button>
</div>
